import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';

const API_URL = 'https://iracing6-backend.herokuapp.com';

function SeriesSafetyWidget({ config }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_URL}/api/series-safety/`);
        if (!response.ok) throw new Error('Failed to fetch data');
        const result = await response.json();
        // Sort by corners per incident (safest first)
        result.sort((a, b) => (b.totalCorners / b.totalIncidents) - (a.totalCorners / a.totalIncidents));
        setData(result);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="widget-loading"><div className="spinner-small"></div></div>;
  }

  if (error) {
    return <div className="widget-error">Error: {error}</div>;
  }

  if (!data || data.length === 0) {
    return <div className="widget-error">No data available</div>;
  }

  // Filter to series with at least 100 entrants and take top 8
  const filteredData = data
    .filter(item => item.totalEntrants >= 100)
    .slice(0, 8);

  const trimSeasonName = (name) => {
    return name
      .replace(/\d{4}\s+Season\s+\d+/g, '')
      .replace(/-/g, ' ')
      .replace(/series/gi, '')
      .replace(/iRacing/gi, '')
      .replace(/\s+/g, ' ')
      .trim()
      .substring(0, 20);
  };

  const plotData = [{
    x: filteredData.map(item => trimSeasonName(item.season_name)),
    y: filteredData.map(item => (item.totalCorners / item.totalIncidents).toFixed(2)),
    type: 'bar',
    marker: {
      color: '#154fa7',
      line: {
        color: '#3e8bff',
        width: 1,
      },
    },
    hovertemplate: '%{y} corners/incident<extra></extra>',
  }];

  const layout = {
    margin: { l: 35, r: 10, t: 10, b: 60 },
    plot_bgcolor: 'transparent',
    paper_bgcolor: 'transparent',
    xaxis: {
      color: '#aaa',
      gridcolor: '#333',
      tickangle: -45,
      tickfont: { size: 8 },
      fixedrange: true,
    },
    yaxis: {
      title: '',
      color: '#aaa',
      gridcolor: '#333',
      fixedrange: true,
    },
    font: {
      family: 'Questrial, sans-serif',
      size: 9,
      color: '#ddd',
    },
    showlegend: false,
    autosize: true,
  };

  return (
    <div className="widget-chart">
      <Plot
        data={plotData}
        layout={layout}
        config={{ displayModeBar: false, responsive: true }}
        style={{ width: '100%', height: '100%' }}
        useResizeHandler={true}
      />
    </div>
  );
}

export default SeriesSafetyWidget;
